<template>
  <div
    class="container login-page-view"
    :style="{
      backgroundImage: backgroundUrl,
      marginTop: margin ? '70px' : '0',
    }"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        class="center-spinner"
        v-if="loading"
      >
        <spinner
          size="100"
          :line-size="15"
          line-fg-color="#78FAAE"
          message="Ładowanie..."
          text-fg-color="white"
        />
      </div>
    </transition>
    <div class="main-wrapper">
      <div class="background-overlay">
        <div class="header-container">
          <h1 class="primary-heading">
            Škoda Online Service Booking
          </h1>
          <p>
            Umów wizytę serwisową Twojego auta przez Internet
          </p>
        </div>
        <login-container />
      </div>
    </div>
  </div>
</template>

<script>
import LoginContainer from '~/LoginContainer.vue';
import Spinner from 'vue-simple-spinner';
import config from '@/config';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    margin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoginContainer,
    Spinner,
  },
  data() {
    return {
      backgroundUrl: null,
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      thirdColor: 'brand/getThirdColor',
    }),
  },
  methods: {
    getBackground() {
      return new Promise((resolve, reject) => {
        const { apiUrl, apiEndpoints } = config;

        axios.get(apiUrl + apiEndpoints.background)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },
  },
  created() {
    this.getBackground()
      .then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 400);
        this.backgroundUrl = `url(${res.data.bgImageUrl})`;
      })
      .catch((err) => {
        this.loading = false;
        console.error(err);
      });
  },
};
</script>
